import { useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { Body, Box, Button, Dialog, H4 } from '../../widgets'
import { SettingsLayout } from '../'
import { subscriptions } from '../../../lookups'
import dayjs from 'dayjs'
import './ConfirmSubscription.scss'

export const ConfirmSubscription = ({ selectedSubscription, onClose }) => {
  const { subscription } = useView('tenant')
  const request = useRequest('tenant')
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false)

  const closeDialog = () => {
    setSubscriptionDialogOpen(false)
    onClose()
  }

  const nextBillingDate = dayjs(subscription.ends).format('MMM D, YYYY')
  const [currentSubscription] = useState(subscriptions[subscription.index] || { teams: 'No subscription', price: 0 })
  const newSubscription = subscriptions[selectedSubscription]

  const proratedPrice = () => {
    const remaining = subscription.ends - Date.now()
    const inYear = dayjs(subscription.ends).diff(dayjs(subscription.ends).subtract(1, 'year'))
    const priceDifference = newSubscription.price - currentSubscription.price
    return remaining / inYear * priceDifference
  }

  const message = () => {
    if(!subscription.ends || subscription.ends < Date.now()) {
      return `Your new subscription will become active immediately and you will be charged $${newSubscription.price}.`
    } else if(currentSubscription.price < newSubscription.price) {
      return `Your new subscription will become active immediately and you will be charged a prorated subscription fee of $${proratedPrice().toFixed(2)}.`
    } else {
      return `Your new subscription will become active at the end of your billing period on ${nextBillingDate}. Your current subscription will remain active until then.`
    }
  }

  const confirmSubscription = () => request('subscriptionSelected', { index: selectedSubscription })
    .then(() => setSubscriptionDialogOpen(true))

  return <SettingsLayout
    onClick={confirmSubscription}
    title="Subscription"
    buttonType="next"
    buttonText="Confirm"
    gap={32}
    onBackButtonClick={onClose}
  >
    <Box border="solid black 1px" radius={16} p={16} gap={16} column fullWidth>
      <Box fullWidth column>
        <Box column gap={4} fullHeight >
          <Body bold>Current subscription</Body>
          {currentSubscription && <Body>
            {`${currentSubscription.teams} for $${currentSubscription.price} p/a`}
          </Body>}
        </Box>
      </Box>
      <Box height={1} background="black" />
        <Box fullWidth column>
          <Box column gap={8} fullHeight >
            <Body bold>New subscription</Body>
            <Body>
              {`${newSubscription.teams} for $${newSubscription.price} p/a`}
            </Body>
          </Box>
        </Box>
    </Box>

    <Body bold>
      {message()}
    </Body>
    <Body>
      Your Shivoo subscription will automatically renew at the updated rate until you cancel. You&apos;re free to cancel anytime.
    </Body>

    <Dialog showControls={false} open={subscriptionDialogOpen} onClose={closeDialog} mobileBackground="white">
      <Box className="updated-subscription-dialog" column gap={16}>
        <H4 color="black">Subscription updated</H4>
        <Body align="center">
          Your subscription has been updated and you will be charged the new amount on {nextBillingDate}.
        </Body>
        <Box p={16} justifyContent="center">
          <Button fullWidth onClick={closeDialog}>
            Got it
          </Button>
        </Box>
      </Box>
    </Dialog>
  </SettingsLayout>
}